module.exports = __webpack_public_path__ + "img/fig9.29.5c5be534.png";